import { createAction } from '@reduxjs/toolkit'
import { call, put, select, StrictEffect, takeEvery } from 'redux-saga/effects'

import { updateSingleDocumentMapping } from './updateSingleDocumentMapping'
import { updateBuilding as updateBuildingAction } from '../../../actions/drawable'
import { updateBuilding } from '../../../api/takeoff-api'
import { DocumentMapping } from '../../../models/documentMapping'
import { Building } from '../../../models/projectBuilding'
import { getProjectBuildings } from '../../../reducers/drawable'
import { RootState } from '../../../stores'
import { selectDocumentMappings } from '../../slices/documents'

export const renamePlanTreeItemAction = createAction<{
    itemId: number | string
    newName: string
    isRootBuilding: boolean
}>('renamePlanTreeItem')

export const selectProjectBuildings = (state: RootState): Building[] => getProjectBuildings(state.drawable)

export function* handleRenamePlanTreeItem(action: ReturnType<typeof renamePlanTreeItemAction>) {
    try {
        const { itemId, newName, isRootBuilding } = action.payload

        if (isRootBuilding) {
            const buildings: Building[] = yield select(selectProjectBuildings)
            const building = buildings.find((building) => building.id === itemId)

            if (!building) return

            const newBuilding = { ...building, name: newName }

            yield call(updateBuilding, newBuilding)
            yield put(updateBuildingAction(newBuilding))
        } else {
            const documentMappings: DocumentMapping[] | null = yield select(selectDocumentMappings)
            const mapping = documentMappings?.find((dm) => dm.document_chunk_id === itemId)

            if (!mapping) return

            yield put(updateSingleDocumentMapping({ ...mapping, page_name: newName }))
        }
    } catch (error) {
        yield call(console.error, error)
    }
}

export function* watchForRenamePlanTreeItem(): Generator<StrictEffect, void, unknown> {
    yield takeEvery(renamePlanTreeItemAction.type, handleRenamePlanTreeItem)
}
